import ReactMarkdown from "react-markdown";

export interface MarkdownTextProps {
  children: string;
  className?: string;
}

export function MarkdownText({ children, className }: MarkdownTextProps) {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          p: ({ children }) => (
            <p className="mb-3 text-[15px] leading-relaxed text-text-secondary last:mb-0">
              {children}
            </p>
          ),
          h2: ({ children }) => (
            <h3 className="mb-2 mt-4 text-[13px] font-semibold uppercase tracking-[0.1em] text-text-primary first:mt-0">
              {children}
            </h3>
          ),
          h3: ({ children }) => (
            <h4 className="mb-2 mt-3 text-[13px] font-semibold uppercase tracking-[0.1em] text-text-primary first:mt-0">
              {children}
            </h4>
          ),
          ul: ({ children }) => (
            <ul className="mb-3 ml-4 list-disc space-y-1 text-[15px] leading-relaxed text-text-secondary last:mb-0">
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol className="mb-3 ml-4 list-decimal space-y-1 text-[15px] leading-relaxed text-text-secondary last:mb-0">
              {children}
            </ol>
          ),
          li: ({ children }) => <li className="pl-1">{children}</li>,
          strong: ({ children }) => (
            <strong className="font-semibold text-text-primary">{children}</strong>
          ),
          em: ({ children }) => <em className="italic">{children}</em>,
          code: ({ children }) => (
            <code className="rounded bg-white/[0.06] px-1.5 py-0.5 text-[13px] text-text-primary">
              {children}
            </code>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
